/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Jai's Portfolio",
  description:
    "A passionate person who always thrives for the perfection of any kind of work and an experienced Full Stack Engineer developing feasible and optimized solutions for any business problem.A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Jaya Krishna Portfolio",
    type: "website",
    url: "/",
  },
};

//Home Page
const greeting = {
  title: "Jaya Krishna",
  logo_name: "Jaya Krishna",
  nickname: "Call me Jai",
  subTitle:
    "A passionate person who always thrives for the perfection of any kind of work and an experienced Full Stack Engineer developing feasible and optimized solutions for any business problem.",
  resumeLink:
    "https://www.linkedin.com/in/jaya-krishna-p-870732ba/",
  portfolio_repository: "https://www.linkedin.com/in/jaya-krishna-p-870732ba/",
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/jai7",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Gmail",
    link: "mailto:princekrish19@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  }
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building web applications using MEAN and MERN stack",
        "⚡ Developing backend web services using Spring Boot, Node and Express"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "logos:html-5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "logos:css-3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "logos:angular-icon",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "logos:spring-icon",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#2C8EBB",
          },
        }
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on cloud platforms like AWS and Heroku",
        "⚡ Hosting applications on various services like EC2, Elastic Bean Stalk etc.",
        "⚡ Designing CICD pipeline which autoamtes the build, test and deploy process.",
        "⚡ Containerizing applications using Docker, Docker compose and deploying them on various services like Amazon ECS, etc. ",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
  
  ],
};

const degrees = {
  degrees: [
    {
      title: "Univeristy of Cincinnati",
      subtitle: "Master of Engineering in CS",
      logo_path: "dal-logo.png",
      alt_name: "University of Cincinnati",
      duration: "2021 - 2021",
      descriptions: [
        "⚡ Cincinnati has enbled me to learn lot of emerging technologies like React, Docker, Node JS and various best industrial practices.",
        "⚡ I have also completed lot of personnel projects during tenure.",
      ],
      website_link: "https://www.uc.edu/",
    },
    {
      title: "Osmania University",
      subtitle: "Bachelor of Engineering in Computer Science",
      logo_path: "anna-logo.png",
      alt_name: "Osmania University",
      duration: "2012 - 2016",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, Web Design, Programming Concepts etc.",
        "⚡ Apart from this, I have done courses on Cloud Computing and Full Stack Development.",
      ],
      website_link: "https://www.osmania.ac.in/",
    },
  ],
};

const certifications = {
  certifications: []
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "",
  description:
    "A Software Engineer with four years of industry experience working with J2EE, Spring Boot and Hibernate. Expertise in developing MEAN, MERN stack applications and cloud platforms like EC2, Elastic Bean Stalk, Code Pipeline, S3 and RDS.",
  header_image_path: "experience.svg",
  sections:
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "Manthan",
          alt_name: "Manthan",
          company_url: "https://www.manthan.com/",
          logo_path: "cra-logo.jpg",
          duration: "August 2019 - December 2020",
          location: "Hyderabad, Telangana, India",
          description:
            "Worked on building/integrating new features into maya, a chat bot application that provides business insights to the clients.",
          color: "#0879bf",
        },
        {
          title: "Software Engineer",
          company: "GEP Worldwide",
          alt_name: "GEP Worldwide",
          company_url: "https://www.gep.com/",
          logo_path: "TechM.png",
          duration: "August 2016 - July 2019",
          location: "Chennai, Tamil Nadu, India",
          description:
            "Worked on full stack development with primary focus on building rest api and services. Had the opportunity to work on critical components and added/integrated new features into the product.",
          color: "#0879bf",
        },
        {
          title: "Member Technical",
          company: "CDK Global",
          alt_name: "CDK Global",
          company_url: "https://www.manthan.com/",
          logo_path: "cra-logo.jpg",
          duration: "August 2019 - December 2020",
          location: "Hyderabad, Telangana, India",
          description:
            "Worked on building/integrating new features into maya, a chat bot application that provides business insights to the clients.",
          color: "#0879bf",
        }
      ],
    },
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have developed various web applications using Angular, React, Node, Express, Java and Spring Boot. I am a clouI have developed various web applications using Angular, React, Node, Express, Java and Spring Boot. I am a cloud enthusiast who likes to design CICD pipelines for all the applications to be automatically deployed to a server. I have expertise in working with AWS services and Containerization tools like Docker.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "jay.jpg",
    description:
      "I like to socialize a lot and please feel free to contact me.I can help you with Full stack web development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Cincinnati, Ohio, USA",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (484) 538-0605",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
